module.exports = __webpack_public_path__ + "img/20210619_172145.b51096e1.jpg";